import { memo } from 'react';

/* =========== ENUM ============ */
export enum MODULE_TYPE {
  AC = 'AC',
  AA = 'AA',
}
export enum ENUM_ORDER_SORT {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum ENUM_PLATFORM {
  WEB = 'web',
  ANDROID = 'android',
  IOS = 'ios',
}

export enum USER_TYPE {
  PARENT = 'PARENT',
  CHILDREN = 'CHILDREN',
}

export enum ACTION_TYPE {
  CREATE = 'create',
  EDIT = 'edit',
  DELETE = 'delete',
  SUBMITTED = 'submitted',
  CANCEL = 'cancel',
  CANCELLED = 'canceled',
  COMPLETED = 'completed',
  EXTEND = 'extend',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  REPORT = 'report',
}

export enum WEB_SOCKET_CONNECTION_STATUS {
  CONNECTED = 'connect',
  CONNECT_ERROR = 'connect_error',
  DISCONNECT = 'disconnect',
  CLOSE = 'close',
}

export enum WEB_SOCKET_EVENTS {
  SEND_MESSAGE = 'send message',
  PAYMENT_SEARCH_FEE_SUCCESS = 'search fee paid successfully',
  PAYMENT_TRIAL_JOB_SUCCESS = 'trial job paid successfully',
  PAYMENT_PACKAGE_PURCHASE_SUCCESS = 'package purchased successfully',
  PAYMENT_JOB_BY_TOP_UP_SUCCESS = 'ac job paid successfully',
  PAYMENT_SEARCH_FEE_FAILED = 'search fee payment failed',
  PAYMENT_TRIAL_JOB_FAILED = 'trial job payment failed',
  PAYMENT_PACKAGE_PURCHASE_FAILED = 'package purchased failed',
  PAYMENT_JOB_BY_TOP_UP_FAILED = 'ac job paid failed',
}

/* =========== INTERFACE ============ */
export type Opt<T> = T | null | undefined;
export type Dict<T> = Record<string, T>;

//models response & error from api
export interface RESPONSE_TYPE<TData = any> {
  status: number;
  message: string;
  data: TData;
}

export interface PAGINATION_TYPE<TData = any> {
  metadata: METADATA;
  rows: TData;
}

export interface PAGINATION2_TYPE<TData = any> {
  metadata: METADATA;
  records: TData;
}

export interface PAGINATION3_TYPE<TData = any> {
  metadata: METADATA;
  data: TData;
}

export interface METADATA {
  // new metadata
  page: number;
  limit: number;
  page_count: number;
  total_pages: number;
  total_count: number;
  offset?: number;
  // old metadata
  pageIndex?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
}

export interface PARAMETERS {
  page?: number;
  limit?: number;
}

export interface REDUX_ACTION_CALLBACK<T = any> {
  onSuccess?: (data?: T) => void;
  onError?: (e: any) => void;
}

export interface REDUX_ACTION_PAYLOAD<T1 = any, T2 = any> {
  data: T1;
  onSuccess?: (data?: T2) => void;
  onError?: (e: any) => void;
}

export interface OPTION_ITEM<T extends any = number> {
  id?: T;
  name: string;
  [key: string]: any;
}

export interface PayloadActionData<T1 extends any = any, T2 extends any = any> {
  data?: T1;
  onSuccess?: (data?: T2) => void;
  onFailed?: (err?: any) => void;
  onFinally?: () => void;
}

export interface PHONE_NUMBER {
  countryCode: string;
  phoneNumber: string;
}

export const typedMemo: <T>(
  c: T,
  areEqual?: (
    prevProps: Readonly<React.PropsWithChildren<T>>,
    nextProps: Readonly<React.PropsWithChildren<T>>,
  ) => boolean,
) => T = memo;

export interface MODAL_ACTION<T extends any = any> {
  data?: T;
  type: ACTION_TYPE;
  custom?: any;
}
